<div class="ne-footer">
  {#if backText}
    <button
      disabled={isSaving}
      data-heap-button='back'
      data-test-id='nav-back'
      class="ne-back-button"
      on:click="{back}">
      {backText}
    </button>
  {/if}

  {#if forwardText}
    {#if isSaving}
      <button
        data-heap-button='next'
        data-test-id='nav-forward'
        class="ne-forward-button"
        disabled=true>
        Saving...
      </button>
    {:else}
      <button
        data-heap-button='next'
        data-test-id='nav-forward'
        class="ne-forward-button"
        disabled={forwardDisabled}
        on:click="{forward}">
        {forwardText}
      </button>
    {/if}
  {/if}
</div>

<style>
  .ne-footer {
    grid-column-start: 1;
    grid-column-end: 4;
    grid-row-start: 5;
    grid-row-end: 5;
    display: grid;
    grid-template-columns: auto auto;

    -ms-grid-columns: 1fr 1fr;
  }

  .ne-back-button {
    grid-column-start: 1;
    justify-self: start;

    -ms-grid-column-align: start;
    -ms-grid-column-justify: start;
    -ms-grid-column-span: 1;
  }

  .ne-forward-button {
    grid-column-start: 2;
    justify-self: end;

    -ms-grid-column-justify: end;
    -ms-grid-column-align: end;
    -ms-grid-column-span: 3;
  }
</style>

<script>
  export let isSaving = false;
  export let back;
  export let backText;
  export let forward;
  export let forwardText;
  export let forwardDisabled = false;
</script>
